module.exports = __webpack_public_path__ + "assets/redpack-meteor-front-1-9e88b4c4.png";